function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "fansi kolekcje",
  transform: "translate(-716.27 -270.27)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20400",
  width: 482.45,
  height: 596.51,
  rx: 50.15,
  transform: "translate(718.77 272.77)",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358295",
  d: "M767.09 272.77h384a50.15 50.15 0 0150.15 50.15v18.62H718.77v-20.45a48.32 48.32 0 0148.32-48.32z",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6717",
  cx: 8.68,
  cy: 8.68,
  r: 8.68,
  transform: "translate(768.05 298.48)",
  fill: "#eae9ee"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6718",
  cx: 8.68,
  cy: 8.68,
  r: 8.68,
  transform: "translate(794.09 298.48)",
  fill: "#eae9ee"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6719",
  cx: 8.68,
  cy: 8.68,
  r: 8.68,
  transform: "translate(820.14 298.48)",
  fill: "#eae9ee"
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20401",
  width: 403.2,
  height: 42.55,
  rx: 21.27,
  transform: "translate(758.4 376.11)",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20402",
  width: 182.3,
  height: 160.94,
  rx: 30.61,
  transform: "translate(759.27 459.99)",
  fill: "#eaf6ef",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20403",
  width: 182.3,
  height: 160.94,
  rx: 30.61,
  transform: "translate(980.17 459.99)",
  fill: "#eaf6ef",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20404",
  width: 182.3,
  height: 160.94,
  rx: 30.61,
  transform: "translate(759.27 653.08)",
  fill: "#eaf6ef",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20405",
  width: 182.3,
  height: 160.94,
  rx: 30.61,
  transform: "translate(980.17 653.08)",
  fill: "#eaf6ef",
  stroke: "#eae9ee",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358296",
  d: "M1141.4 715.4l-40.85-21.49a4.86 4.86 0 00-6.56 2l-.48.91-29.27-6.2a4.88 4.88 0 00-5.76 3.76l-.32 1.55-24.14.8a4.86 4.86 0 00-4.7 5l.15 4.48-18 4.53a4.87 4.87 0 00-3.53 5.9l16.09 64a4.87 4.87 0 004.72 3.67 5.276 5.276 0 001.18-.14l44.74-11.17a4.869 4.869 0 002.74-1.88h1l10.28 2.17 17.45 9.18a4.779 4.779 0 002.25.56 4.86 4.86 0 004.31-2.6l30.74-58.43a4.87 4.87 0 00-2-6.56zm-44.54-17.95a1.49 1.49 0 011-.78 2 2 0 011.23.1c1 .51 4 2.09 4 2.09l-6.19-1.31zm-35.2-2.37a1.62 1.62 0 011.57-1.28 1.321 1.321 0 01.34 0l8 1.68-10 .33zm13.2 74a1.58 1.58 0 01-1 .73l-44.77 11.26a1.62 1.62 0 01-2-1.17l-16.09-64a1.61 1.61 0 011.16-2l44.84-11.21a1.57 1.57 0 011.93 1.11v.05l.31 1.27 14.35 56.88 1.46 5.83a1.591 1.591 0 01-.19 1.22zm8.8-1.92a1.61 1.61 0 01-1.12.51h-4.25a2.251 2.251 0 00-.09-.63l-1.29-5.14 2.07-.07-.62-18.72-6.13.21-.81-3.23 6.83-.22-1.16-35.37-14.51.47-.48-2a4.86 4.86 0 00-5.89-3.52l-23.52 5.91-.12-3.78a1.6 1.6 0 01.43-1.16 1.671 1.671 0 011.13-.51l46.13-1.51h.06a1.63 1.63 0 011.61 1.56l.12 3.76 1.2 36.43.11 3.35.62 19.28.11 3.15a1.59 1.59 0 01-.43 1.15zm13.22 0l-.57 2.7a1.62 1.62 0 01-1.92 1.24l-8.34-1.76a4.85 4.85 0 001.29-3.45l-.08-2.35 5.07 1.07 3.88-18.32-9.59-2-.1-3.35 10.36 2.2 7.34-34.62-18.9-4-.16-4.56a4.929 4.929 0 00-.34-1.61l23.91 5.06a1.61 1.61 0 011.24 1.91l-.74 3.54-7.62 36-.7 3.3-4 19zm43.69-46.74l-30.73 58.42a1.62 1.62 0 01-2.18.67l-10.76-5.66a4.84 4.84 0 002.58-3.32l.38-1.81 7.58 4 8.72-16.57-12.27-6.46.71-3.3 13.08 6.88 16.48-31.27-22-11.55 1-4.43a5.2 5.2 0 000-1.76l26.7 14a1.61 1.61 0 01.68 2.17z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358297",
  d: "M1017 718.87l38.25-9.62 8.64 34.34-38.26 9.62z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358298",
  d: "M1026.37 756.37l38.26-9.62 4.56 18.16-38.25 9.62z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358299",
  d: "M823.24 763.16h63.11a2.6 2.6 0 00.56-.07 2.44 2.44 0 002.44-2.44v-69a2.44 2.44 0 00-2.35-2.45h-63.7a11.8 11.8 0 00-11.84 11.8 2.148 2.148 0 000 .25c0 6-.09 61.15 0 68.4v.42a11.79 11.79 0 0011 11.75 2.455 2.455 0 00.37 0H887a2.44 2.44 0 002.44-2.44v-9.19a2.44 2.44 0 00-4.88 0V777h-61.32a6.89 6.89 0 01-6.88-6.62v-.69a6.91 6.91 0 016.88-6.53zm1.67-62.16a2.44 2.44 0 014.88 0v49.59a2.44 2.44 0 01-4.88 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358300",
  d: "M1098.13 528.21h-14.88v-8.92h-23.81v8.92h-14.88a9 9 0 00-8.93 8.93v48a9 9 0 008.93 8.93h53.57a8.94 8.94 0 008.93-8.93v-48a8.94 8.94 0 00-8.93-8.93zM1095 544a109 109 0 00-5.8 35.17 3 3 0 01-3 3h-29.76a3 3 0 01-3-3 99.522 99.522 0 00-5.78-35.1 3 3 0 012.8-4h41.67A3 3 0 011095 544z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358301",
  d: "M1059.44 576.23h23.85a116.091 116.091 0 014.81-30.16h-33.44a105.573 105.573 0 014.78 30.16z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358302",
  d: "M1050.51 513.33h41.67a3 3 0 003-3v-14.85a3 3 0 00-3-3h-41.67a3 3 0 00-3 3v14.88a3 3 0 003 2.97z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358303",
  d: "M906.16 516.74l-.08-.08L882.82 496a2.368 2.368 0 00-.73-.44l-16.83-6a2.2 2.2 0 00-2.83 1.32 2 2 0 00-.13.64c0 .49-.73 11.7-11.95 11.88-11.27-.18-12-11.39-12-11.88a2.22 2.22 0 00-2.35-2.12 2.634 2.634 0 00-.62.13l-16.8 6.08a2.262 2.262 0 00-.73.44l-23.11 20.61a2.21 2.21 0 00-.08 3.13l.08.08 18.4 18.59v50.87a2.21 2.21 0 002.21 2.21h70.1a2.21 2.21 0 002.21-2.21v-50.87l18.4-18.59a2.21 2.21 0 00.1-3.13zm-18.54 15.42V521.9a2.22 2.22 0 00-4.43 0V587h-65.7v-65.1a2.21 2.21 0 00-4.42 0v10.28l-13.6-13.77 21-18.84 13.85-5a16.29 16.29 0 0032 0l13.85 5 21 18.84z",
  fill: "#fff"
}));

function SvgFansiCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487.47 601.51",
    className: "w-full h-full"
  }, props), _ref);
}

export default SvgFansiCollections;